module.exports = __webpack_public_path__ + "static/media/21ECLAC52.d76c98ae.jpg";